module.exports = __webpack_public_path__ + "img/france-flag.6e9f02f2.svg";